import './_style.scss';
import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import warning from '../../../../assets/img/brand/warning.svg';

const ModalGeracaoProtocolo = ({
  isOpen,
  toggle,
  erroProtocolo,
  imprimirProtocolo,
  numeroProtocoloGerado,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    className="modal-md modal-default"
    backdrop={false}
  >
    <ModalHeader className="header-success">
      Protocolo em processo de geração.
    </ModalHeader>
    <ModalBody>
      <p>
        O protocolo de número
        <span className="font-weight-bold">
          {'  '}
          {numeroProtocoloGerado}
          {'  '}
        </span>
        está na fila do protocolar. Você será notificado quando o processo terminar.
      </p>
      <p>
        Evite os apontamentos de
        {' '}
        <span className="label_danger">pendências</span>
        . Envie imediatamente os documentos para a guarda física.
      </p>
  </ModalBody>
  <ModalFooter>
    <Button className="secondary" onClick={toggle}>
      Continuar
    </Button>
  </ModalFooter>
</Modal>
);

export default ModalGeracaoProtocolo;
